import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventory-report',
  templateUrl: './inventory-report.component.html',
  styleUrls: ['./inventory-report.component.css']
})
export class InventoryReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
